export enum TicketsRoutes {
  All = "all",
  Unassigned = "unassigned",
  MyOpen = "my-open",
  Open = "open",
  Pending = "pending",
  OnHold = "onhold",
  Solved = "solved",
  Closed = "closed",
  Archive = "archive",
  Spam = "spam",
  Trash = "trash",
  Search = "search",
  Undelivered = "undelivered",
}

export const routeTitles = {
  [TicketsRoutes.All]: "All recent tickets",
  [TicketsRoutes.Unassigned]: "Tickets to handle",
  [TicketsRoutes.MyOpen]: "My open tickets",
  [TicketsRoutes.Open]: "Open",
  [TicketsRoutes.Pending]: "Pending",
  [TicketsRoutes.OnHold]: "On hold",
  [TicketsRoutes.Solved]: "Solved",
  [TicketsRoutes.Closed]: "Closed",
  [TicketsRoutes.Archive]: "Archive",
  [TicketsRoutes.Spam]: "Spam",
  [TicketsRoutes.Trash]: "Trash",
  [TicketsRoutes.Search]: "Search",
  [TicketsRoutes.Undelivered]: "Undelivered",
};

export const getPathForRoute = (route: TicketsRoutes | null | undefined): string => {
  if (!route) {
    return "/tickets";
  }
  return `/tickets/${route}`;
};
